// run `npm run mock` to start development mock server
export const WEB_BASE_PATH = process.env.VUE_APP_BASE_PATH;
export const SFDC_API_PATH = process.env.VUE_APP_SFDC_API_PATH;
export const ECPAY_API_PATH = process.env.VUE_APP_ECPAY_API_PATH;
export const LINEPAY_API_PATH = process.env.VUE_APP_LINEPAY_API_PATH;
export const JKOPAY_API_PATH = process.env.VUE_APP_JKOPAY_API_PATH;
export const SFDC_API_TOKEN = process.env.VUE_APP_SFDC_API_TOKEN;